// @ts-nocheck
import {
  CLEAR_EMAIL_REDIRECTION_REDUCER,
  SETUP_EMAIL_REDIRECTION_PATH,
} from "../constants/emailRedirectionConstants";

const initialState = {
  path: "",
  data: null,
  forUser: null,
};

const emailRedirectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SETUP_EMAIL_REDIRECTION_PATH: {
      return {
        ...state,
        path: action?.payload?.path,
        data: action?.payload?.data,
        forUser: action?.payload?.user,
      };
    }

    case CLEAR_EMAIL_REDIRECTION_REDUCER: {
      return {
        ...initialState,
      };
    }

    default:
      return state;
  }
};

export default emailRedirectionReducer;
export { initialState };